import type{ HubConnection, IStreamResult } from "@microsoft/signalr"

export type UnregisterHandler = () => void;
export const ApiHash: string = "bc1477fe602773ac2339c96b0329aed5";

export class CashierServerHub {
    constructor(protected connection: HubConnection) {
    }




    gameServerList(req: AuthenticatedRequest): Promise<ApiResultOfListOfGameServerDTO> {
        return this.connection.invoke("GameServerList", req);
    }

    addGameServer(req: AuthenticatedRequestOfAddGameServerDTO): Promise<ApiResultOfGameServerDTO> {
        return this.connection.invoke("AddGameServer", req);
    }

    editGameServer(req: AuthenticatedRequestOfEditGameServerDTO): Promise<ApiResultOfGameServerDTO> {
        return this.connection.invoke("EditGameServer", req);
    }

    addGame(addGame: AuthenticatedRequestOfAddGameDTO): Promise<ApiResultOfGame> {
        return this.connection.invoke("AddGame", addGame);
    }

    editGame(editGame: AuthenticatedRequestOfEditGameDTO): Promise<ApiResultOfGame> {
        return this.connection.invoke("EditGame", editGame);
    }

    launchRealGame(req: AuthenticatedRequestOfLauchTokenRequest): Promise<ApiResultOfLaunchTokenDTO> {
        return this.connection.invoke("LaunchRealGame", req);
    }

    groupList(req: AuthenticatedRequest): Promise<ApiResultOfListOfGroupDTO> {
        return this.connection.invoke("GroupList", req);
    }

    addGroup(req: AuthenticatedRequestOfAddGroupRequest): Promise<ApiResultOfGroupDTO> {
        return this.connection.invoke("AddGroup", req);
    }

    editGroup(req: AuthenticatedRequestOfEditGroupDTO): Promise<ApiResultOfGroupDTO> {
        return this.connection.invoke("EditGroup", req);
    }

    playGroupsList(req: AuthenticatedRequest): Promise<ApiResultOfListOfPlayGroupDTO> {
        return this.connection.invoke("PlayGroupsList", req);
    }

    addPlayGroup(req: AuthenticatedRequestOfAddPlayGroupRequest): Promise<ApiResultOfPlayGroupDTO> {
        return this.connection.invoke("AddPlayGroup", req);
    }

    editPlayGroup(req: AuthenticatedRequestOfEditPlayGroupDTO): Promise<ApiResultOfPlayGroupDTO> {
        return this.connection.invoke("EditPlayGroup", req);
    }

    addGamesGroups(req: AuthenticatedRequestOfAddGamesGroupsRequest): Promise<ApiResultOfGamesGroupsDTO> {
        return this.connection.invoke("AddGamesGroups", req);
    }

    removeGamesGroups(req: AuthenticatedRequestOfAddGamesGroupsRequest): Promise<ApiResultOfString> {
        return this.connection.invoke("RemoveGamesGroups", req);
    }

    withdrawalPin(withdrawpinDTO: AuthenticatedRequestOfWithdrawPinRequest): Promise<ApiResultOfWalletTransaction> {
        return this.connection.invoke("WithdrawalPin", withdrawpinDTO);
    }

    searchbydate(req: AuthenticatedRequestOfTransactionDateRequest): Promise<ApiResultOfListOfTransactionDateResponse> {
        return this.connection.invoke("searchbydate", req);
    }

    userbytransaction(req: AuthenticatedRequestOfUserbyTransactionRequest): Promise<ApiResultOfPaginatedUserbyTransactionResponse> {
        return this.connection.invoke("userbytransaction", req);
    }

    transactionperuser(req: AuthenticatedRequestOfTransactionperuserRequest): Promise<ApiResultOfListOfTransactionperuserResponse> {
        return this.connection.invoke("transactionperuser", req);
    }

    reportGame(req: AuthenticatedRequestOfWalletTransactionRequest): Promise<ApiResultOfListOfReportGameResponse> {
        return this.connection.invoke("ReportGame", req);
    }

    getRealLinkRound(req: AuthenticatedRequestOfLinkGameRoundRequest): Promise<ApiResultOfLinkGameRoundResponse> {
        return this.connection.invoke("GetRealLinkRound", req);
    }

    gameRound(req: AuthenticatedRequestOfGameRoundRequetsDTO): Promise<ApiResultOfPaginatedGameRoundResponse> {
        return this.connection.invoke("GameRound", req);
    }

    sumByDateDebit(req: AuthenticatedRequestOfDataRequest): Promise<ApiResultOfGroupedDataResponse> {
        return this.connection.invoke("sumByDateDebit", req);
    }

    detailspercashier(req: AuthenticatedRequestOfDataRequestCashier): Promise<ApiResultOfListOfDetailsPerCashierResponse> {
        return this.connection.invoke("Detailspercashier", req);
    }

    detailspercashierdates(req: AuthenticatedRequestOfDataRequestCashierDetails): Promise<ApiResultOfDetailsPerCashierResponse> {
        return this.connection.invoke("Detailspercashierdates", req);
    }

    transactionbycashier(req: AuthenticatedRequestOfDataRequestCashier): Promise<ApiResultOfDataResponseCashier> {
        return this.connection.invoke("Transactionbycashier", req);
    }

    gamesList(req: AuthenticatedRequest): Promise<ApiResultOfListOfGame> {
        return this.connection.invoke("GamesList", req);
    }

    adminList(req: AuthenticatedRequest): Promise<ApiResultOfListOfUser> {
        return this.connection.invoke("AdminList", req);
    }

    cashierList(req: AuthenticatedRequest): Promise<ApiResultOfListOfUser> {
        return this.connection.invoke("CashierList", req);
    }

    playerList(req: AuthenticatedRequest): Promise<ApiResultOfListOfUser> {
        return this.connection.invoke("PlayerList", req);
    }

    listAllUsers(req: AuthenticatedRequest): Promise<ApiResultOfListOfUser> {
        return this.connection.invoke("ListAllUsers", req);
    }

    unassignedUsers(req: AuthenticatedRequest): Promise<ApiResultOfListOfUser> {
        return this.connection.invoke("UnassignedUsers", req);
    }

    transactionList(req: AuthenticatedRequest): Promise<ApiResultOfListOfWalletTransaction> {
        return this.connection.invoke("TransactionList", req);
    }

    assignGroup(req: AuthenticatedRequestOfAssignGroupRequest): Promise<ApiResultOfAssignGroupResponse> {
        return this.connection.invoke("AssignGroup", req);
    }

    disableGame(req: AuthenticatedRequestOfDisableGameDTO): Promise<ApiResultOfPublicGamesDTO> {
        return this.connection.invoke("DisableGame", req);
    }

    disableInPage(req: AuthenticatedRequestOfDisableInPageDTO): Promise<ApiResultOfPublicGamesDTO> {
        return this.connection.invoke("DisableInPage", req);
    }

    deleteGroup(req: AuthenticatedRequestOfDeleteGroupDTO): Promise<ApiResultOfDeleteGroupResponseDTO> {
        return this.connection.invoke("DeleteGroup", req);
    }

    needToAddFirstOwner(): Promise<ApiResult> {
        return this.connection.invoke("NeedToAddFirstOwner");
    }

    addFirstOwner(addUser: AddUserWithPinDTO): Promise<ApiResultOfPublicUserDTO> {
        return this.connection.invoke("AddFirstOwner", addUser);
    }

    addUser(addUser: AuthenticatedRequestOfAddUserDTO): Promise<ApiResultOfPublicUserDTO> {
        return this.connection.invoke("AddUser", addUser);
    }

    disableUser(req: AuthenticatedRequestOfDisableUserDTO): Promise<ApiResultOfPublicUserDTO> {
        return this.connection.invoke("DisableUser", req);
    }

    editUser(editUser: AuthenticatedRequestOfEditUserDTO): Promise<ApiResultOfPublicUserDTO> {
        return this.connection.invoke("EditUser", editUser);
    }

    printAddUser(printUser: AuthenticatedRequestOfPrintAddUserDTO): Promise<ApiResult> {
        return this.connection.invoke("PrintAddUser", printUser);
    }

    printEditUser(printUser: AuthenticatedRequestOfPrintEditUserDTO): Promise<ApiResult> {
        return this.connection.invoke("PrintEditUser", printUser);
    }

    printUser(printUser: AuthenticatedRequestOfPrintUserDTO): Promise<ApiResult> {
        return this.connection.invoke("PrintUser", printUser);
    }

    loginWithPin(login: LoginWalletDTO): Promise<ApiResultOfLoginDTO> {
        return this.connection.invoke("LoginWithPin", login);
    }

    me(req: AuthenticatedRequest): Promise<ApiResultOfLoginDTO> {
        return this.connection.invoke("Me", req);
    }

    settings(): Promise<CashierSettings> {
        return this.connection.invoke("Settings");
    }

    deposit(depositDTO: AuthenticatedRequestOfDepositWithdrawDTO): Promise<ApiResultOfWalletTransaction> {
        return this.connection.invoke("Deposit", depositDTO);
    }

    promotionalDeposit(depositDTO: AuthenticatedRequestOfDepositWithdrawDTO): Promise<ApiResultOfWalletTransaction> {
        return this.connection.invoke("PromotionalDeposit", depositDTO);
    }

    withdraw(withdrawDTO: AuthenticatedRequestOfDepositWithdrawDTO): Promise<ApiResultOfWalletTransaction> {
        return this.connection.invoke("Withdraw", withdrawDTO);
    }

    cancelTransaction(req: AuthenticatedRequestOfCancelTransactionRequest): Promise<ApiResultOfWalletTransaction> {
        return this.connection.invoke("CancelTransaction", req);
    }

    printTransaction(printTransactionDTO: AuthenticatedRequestOfPrintTransactionDTO): Promise<ApiResult> {
        return this.connection.invoke("PrintTransaction", printTransactionDTO);
    }

    addBanner(req: AuthenticatedRequestOfAddBannerDTO): Promise<ApiResultOfBannersDTO> {
        return this.connection.invoke("AddBanner", req);
    }

    bannersList(req: AuthenticatedRequest): Promise<ApiResultOfListOfBannersDTO> {
        return this.connection.invoke("BannersList", req);
    }

    editBanner(req: AuthenticatedRequestOfEditBannerDTO): Promise<ApiResultOfBannersDTO> {
        return this.connection.invoke("EditBanner", req);
    }

    disableBanner(req: AuthenticatedRequestOfDisableBannerDTO): Promise<ApiResultOfBannersDTO> {
        return this.connection.invoke("DisableBanner", req);
    }

    campaignsList(req: AuthenticatedRequest): Promise<ApiResultOfListOfCampaignsDTO> {
        return this.connection.invoke("CampaignsList", req);
    }

    addCampaigns(req: AuthenticatedRequestOfAddCampaignsDTO): Promise<ApiResultOfCampaignsDTO> {
        return this.connection.invoke("AddCampaigns", req);
    }

    editCampaigns(req: AuthenticatedRequestOfEditCampaignsDTO): Promise<ApiResultOfCampaignsDTO> {
        return this.connection.invoke("EditCampaigns", req);
    }

    addGroupLimit(req: AuthenticatedRequestOfAddGroupLimitDto): Promise<ApiResultOfGroupLimitResponse> {
        return this.connection.invoke("AddGroupLimit", req);
    }

    groupLimitList(req: AuthenticatedRequest): Promise<ApiResultOfListOfGroupLimitResponse> {
        return this.connection.invoke("GroupLimitList", req);
    }

    editGroupLimit(req: AuthenticatedRequestOfEditGroupLimitDTO): Promise<ApiResultOfGroupLimitDTO> {
        return this.connection.invoke("EditGroupLimit", req);
    }

    disableGroupLimit(req: AuthenticatedRequestOfDisableGroupLimitDto): Promise<ApiResultOfGroupLimitDTO> {
        return this.connection.invoke("DisableGroupLimit", req);
    }

    transactionbyLimit(req: AuthenticatedRequestOfTransactionbyLimitDTO): Promise<ApiResultOfTransactionbyLimitResponse> {
        return this.connection.invoke("TransactionbyLimit", req);
    }

    addConfiguration(req: AuthenticatedRequestOfAddConfigurationDTO): Promise<ApiResultOfConfigurationResponse> {
        return this.connection.invoke("AddConfiguration", req);
    }

    configurationList(req: AuthenticatedRequest): Promise<ApiResultOfListOfConfigurationResponse> {
        return this.connection.invoke("ConfigurationList", req);
    }

    editConfiguration(req: AuthenticatedRequestOfEditConfigurationDTO): Promise<ApiResultOfConfigurationDTO> {
        return this.connection.invoke("EditConfiguration", req);
    }


    protected operationHandlers: Map<string, any> = new Map<string, any>();
    public registerOperation<T extends CashierServerOperationName>(operation: T, handlerName: string, handler: CashierServerOperationHandler<T>): UnregisterHandler {
        let operationHandlerName = `${operation}=>${handlerName}`;

        if (this.operationHandlers.has(operationHandlerName))
        {
            throw `Handler ${handlerName} for operation ${operation} already set`;
        }

        let safeSignalRHandler = (...args: any[]) =>
        {
            try
            {
                (handler as any).apply(null, args);
            }
            catch (ex)
            {
                console.error("Error in signalR handler", ex);
            }
        }

        this.operationHandlers.set(operationHandlerName, safeSignalRHandler);
        this.connection.on(operation, safeSignalRHandler);

        let unregisterHandler = () => {
            this.unregisterOperation(operation, handlerName);
        };
        
        return unregisterHandler;
    }

    public unregisterOperation<T extends CashierServerOperationName>(operation: T, handlerName: string) {
        let operationHandlerName = `${operation}=>${handlerName}`;
        let handler = this.operationHandlers.get(operationHandlerName)
        if (handler)
        {
            this.operationHandlers.delete(operationHandlerName);
            this.connection.off(operation, handler);
        }
    }
}

export interface CashierServerHandlers {
    "SettingsChanged": (settings: CashierSettings) => void;
    "NewSession": (session: PlayersSession) => void;
    "RemoveSession": (session: PlayersSession) => void;
    "UpdateSession": (session: PlayersSession) => void;
    "NewTransaction": (transaction: WalletTransaction) => void;
    "UserAdded": (user: User) => void;
    "AdminAdded": (user: User) => void;
    "CashierAdded": (user: User) => void;
    "PlayerAdded": (user: User) => void;
    "AdminChanged": (user: User) => void;
    "CashierChanged": (user: User) => void;
    "PlayerChanged": (user: User) => void;
    "UserChanged": (user: User) => void;
    "GameAdded": (games: Game) => void;
    "GameChanged": (games: Game) => void;
    "DeleteGroup": (group: Group) => void;
    "TransactionAdded": (transaction: WalletTransaction) => void;
    "expiredpromotions": (transaction: WalletTransaction) => void;
    "TransactionChanged": (transaction: WalletTransaction) => void;
    "GameServerAdded": (gameServer: GameServerDTO) => void;
    "GameServerChanged": (gameServer: GameServerDTO) => void;
    "BannerAdded": (Banner: BannersDTO) => void;
    "BannerChanged": (Banner: Banners) => void;
    "CampaignsAdded": (campaigns: CampaignsDTO) => void;
    "CampaignsChanged": (campaigns: CampaignsDTO) => void;
    "GroupAdded": (group: GroupDTO) => void;
    "GroupChanged": (group: GroupDTO) => void;
    "PlayGroupAdded": (playgroup: PlayGroupDTO) => void;
    "PlayGroupChanged": (playgroup: PlayGroupDTO) => void;
    "GamesGroupsAdded": (gamesgroup: GamesGroupsDTO) => void;
    "GamesGroupsRemoved": (gamesgroup: GamesGroupsDTO) => void;
    "GroupLimitAdded": (grouplimits: GroupLimits) => void;
    "GroupLimitEdited": (grouplimits: GroupLimits) => void;
    "ConfigurationEdited": (configuration: Configuration) => void;
    "GroupLimitChanged": (grouplimits: GroupLimitDTO) => void;
    "ConfigurationAdded": (config: Configuration) => void;
}

export type CashierServerOperationName = keyof CashierServerHandlers;
export type CashierServerOperationHandler<T extends CashierServerOperationName> = CashierServerHandlers[T];

export interface AuthenticatedRequest {
    Token: string | undefined;
}

export interface ApiResultOfListOfGameServerDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: GameServerDTO[] | undefined;
}

export interface GameServerDTO {
    Id: number;
    Label: string | undefined;
    User: string | undefined;
    Password: string | undefined;
    Endpoint: string | undefined;
}

export interface AuthenticatedRequestOfAddGameServerDTO {
    Token: string | undefined;
    Data: AddGameServerDTO | undefined;
}

export interface AddGameServerDTO {
    Label: string | undefined;
    User: string | undefined;
    Password: string | undefined;
    Endpoint: string | undefined;
}

export interface ApiResultOfGameServerDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: GameServerDTO | undefined;
}

export interface AuthenticatedRequestOfEditGameServerDTO {
    Token: string | undefined;
    Data: EditGameServerDTO | undefined;
}

export interface EditGameServerDTO {
    Id: number;
    Label: string | undefined;
    User: string | undefined;
    Password: string | undefined;
    Endpoint: string | undefined;
}

export interface AuthenticatedRequestOfAddGameDTO {
    Token: string | undefined;
    Data: AddGameDTO | undefined;
}

export interface AddGameDTO {
    GameName: string | undefined;
    GameCode: string | undefined;
    Select: string | undefined;
    Enabled: boolean;
    GameServerId: number;
}

export interface ApiResultOfGame {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: Game | undefined;
}

export interface Game {
    Id: number;
    GameName: string | undefined;
    GameCode: string | undefined;
    Enabled: boolean;
    Select: string | undefined;
    GameServerId: number;
    GameServer: GameServer | undefined;
    GameGroup: GameGroup[] | undefined;
    ShowOnMainPage: boolean;
}

export interface GameServer {
    Id: number;
    Label: string | undefined;
    User: string | undefined;
    Password: string | undefined;
    Endpoint: string | undefined;
    Games: Game[] | undefined;
}

export interface GameGroup {
    GameId: number | undefined;
    Game: Game | undefined;
    PlayGroupsId: number | undefined;
    PlayGroups: PlayGroups | undefined;
}

export interface PlayGroups {
    Id: number;
    Label: string | undefined;
    GroupName: string | undefined;
    GameGroup: GameGroup[] | undefined;
}

export interface AuthenticatedRequestOfEditGameDTO {
    Token: string | undefined;
    Data: EditGameDTO | undefined;
}

export interface EditGameDTO {
    Id: number;
    GameName: string | undefined;
    GameCode: string | undefined;
    Enabled: boolean;
    Select: string | undefined;
    GameServerId: number;
}

export interface AuthenticatedRequestOfLauchTokenRequest {
    Token: string | undefined;
    Data: LauchTokenRequest | undefined;
}

export interface LauchTokenRequest {
    GameId: number;
}

export interface ApiResultOfLaunchTokenDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: LaunchTokenDTO | undefined;
}

export interface LaunchTokenDTO {
    GameName: string | undefined;
    Link: string | undefined;
}

export interface ApiResultOfListOfGroupDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: GroupDTO[] | undefined;
}

export interface GroupDTO {
    Id: number;
    Name: string | undefined;
    ParentId: number | undefined;
    Users: User[] | undefined;
}

export interface User {
    Id: number;
    Email: string | undefined;
    Password: string | undefined;
    PhoneNumber: string | undefined;
    FirstName: string | undefined;
    LastName: string | undefined;
    Enabled: boolean;
    Role: UserRole;
    BirthdayDay: Date;
    Reference: string | undefined;
    CountryCode: string | undefined;
    CurrencyCode: string | undefined;
    Language: string | undefined;
    LastWalletTransactionId: number | undefined;
    LastWalletTransaction: WalletTransaction | undefined;
    WalletTransactions: WalletTransaction[] | undefined;
    PlayerSessions: PlayersSession[] | undefined;
    GroupId: number | undefined;
    Group: Group | undefined;
    Campaigns: Campaigns[] | undefined;
    UserPromotional: UserPromotional[] | undefined;
    Dailylimit: Money | undefined;
    Txlimit: Money | undefined;
    LastTransactionUserId: number | undefined;
}

export enum UserRole {
    Owner = "Owner",
    Admin = "Admin",
    Cashier = "Cashier",
    Player = "Player",
}

export interface WalletTransaction {
    Id: number;
    RoundId: string | undefined;
    TransactionId: string | undefined;
    Type: WalletTransactionType;
    TransactionTime: Date;
    LasTransactionId: string | undefined;
    UserId: number;
    User: User | undefined;
    UserLastTransaction: User | undefined;
    IdPlayerSession: number;
    PlayerSession: PlayersSession | undefined;
    NoncashableAmount: Money | undefined;
    NoncashableBalance: Money | undefined;
    PinWithdraw: string | undefined;
    CashableAmount: Money | undefined;
    CashableBalance: Money | undefined;
    GameRoundId: number | undefined;
    GameRound: GameRound | undefined;
    MoneyTransaction: MoneyTransaction[] | undefined;
    PromotionTransactions: PromotionTransactions[] | undefined;
    OperatorId: number | undefined;
    Operator: User | undefined;
}

export enum WalletTransactionType {
    Debit = "Debit",
    Credit = "Credit",
    EndRound = "EndRound",
    CancelBet = "CancelBet",
    Deposit = "Deposit",
    Withdraw = "Withdraw",
    DepositCancel = "DepositCancel",
    WithdrawCancel = "WithdrawCancel",
    WithdrawWaiting = "WithdrawWaiting",
    PromoCanceled = "PromoCanceled",
    PromoExpired = "PromoExpired",
}

export interface PlayersSession {
    Id: number;
    LoadToken: string | undefined;
    AuthToken: string | undefined;
    Date: Date;
    Start: Date;
    End: Date;
    PlayerId: number | undefined;
    Player: User | undefined;
    GameId: number | undefined;
    Game: Game | undefined;
    reminder_sent_date: Date;
}

export interface Money {
    InCents: number;
}

export interface GameRound {
    Id: number;
    Date: Date;
    RoundId: string | undefined;
    PlayerId: number;
    Player: User | undefined;
    GameId: number;
    Game: Game | undefined;
    CountryCode: string | undefined;
    Bet: Money | undefined;
    Win: Money | undefined;
    PlayerSesionId: number;
    PlayerSession: PlayersSession | undefined;
    Transactions: WalletTransaction[] | undefined;
}

export interface MoneyTransaction {
    Id: number;
    WalletTransactionId: number;
    WalletTransaction: WalletTransaction | undefined;
    Amount: Money | undefined;
    Balance: Money | undefined;
}

export interface PromotionTransactions {
    Id: number;
    WalletTransactionId: number;
    WalletTransaction: WalletTransaction | undefined;
    CampaignsId: number;
    Campaigns: Campaigns | undefined;
    InitialBalance: Money | undefined;
    Amount: Money | undefined;
    Balance: Money | undefined;
    StartDate: Date;
    ExpirationDate: Date;
}

export interface Campaigns {
    Id: number;
    Type: TypePromotion;
    PromotionName: string | undefined;
    Description: string | undefined;
    StartAmount: Money | undefined;
    DepositRequired: boolean;
    Active: boolean;
    TotalDays: string;
    ExpirationDate: Date;
    Settings: string | undefined;
    DurationDisplay: string | undefined;
    Days: number;
    Hours: number;
    Minutes: number;
    Seconds: number;
    UserPromotional: UserPromotional[] | undefined;
}

export enum TypePromotion {
    Register = "Register",
    Birthday = "Birthday",
    HappyFriday = "HappyFriday",
    WelcomeBonus = "WelcomeBonus",
    DailyBonus = "DailyBonus",
    Manual = "Manual",
    Recharge = "Recharge",
}

export interface UserPromotional {
    Id: number;
    UserId: number;
    User: User | undefined;
    CampaignsId: number;
    Campaigns: Campaigns | undefined;
    PromotionalCreditId: number;
    StartAmount: Money | undefined;
    Amount: number;
    Balance: Money | undefined;
    State: PromotionStatus;
    StartDate: Date;
    ExpirationDate: Date;
    BetAmount: Money | undefined;
    CanWithdrawProfits: boolean;
}

export enum PromotionStatus {
    Active = "Active",
    Complete = "Complete",
    Expired = "Expired",
    Cancelled = "Cancelled",
    Pending = "pending",
}

export interface Group {
    Id: number;
    Name: string | undefined;
    ParentId: number | undefined;
    Users: User[] | undefined;
}

export interface AuthenticatedRequestOfAddGroupRequest {
    Token: string | undefined;
    Data: AddGroupRequest | undefined;
}

export interface AddGroupRequest {
    Name: string | undefined;
    ParentId: number | undefined;
    UserId: string | undefined;
}

export interface ApiResultOfGroupDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: GroupDTO | undefined;
}

export interface AuthenticatedRequestOfEditGroupDTO {
    Token: string | undefined;
    Data: EditGroupDTO | undefined;
}

export interface EditGroupDTO {
    Id: number;
    Name: string | undefined;
    ParentId: number | undefined;
}

export interface ApiResultOfListOfPlayGroupDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: PlayGroupDTO[] | undefined;
}

export interface PlayGroupDTO {
    Id: number;
    Label: string | undefined;
    GroupName: string | undefined;
}

export interface AuthenticatedRequestOfAddPlayGroupRequest {
    Token: string | undefined;
    Data: AddPlayGroupRequest | undefined;
}

export interface AddPlayGroupRequest {
    Label: string | undefined;
    GroupName: string | undefined;
}

export interface ApiResultOfPlayGroupDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: PlayGroupDTO | undefined;
}

export interface AuthenticatedRequestOfEditPlayGroupDTO {
    Token: string | undefined;
    Data: EditPlayGroupDTO | undefined;
}

export interface EditPlayGroupDTO {
    Id: number;
    Label: string | undefined;
    GroupName: string | undefined;
}

export interface AuthenticatedRequestOfAddGamesGroupsRequest {
    Token: string | undefined;
    Data: AddGamesGroupsRequest | undefined;
}

export interface AddGamesGroupsRequest {
    GameId: number;
    PlayGroupsIds: number[] | undefined;
}

export interface ApiResultOfGamesGroupsDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: GamesGroupsDTO | undefined;
}

export interface GamesGroupsDTO {
    GameId: number | undefined;
    PlayGroupsId: number | undefined;
}

export interface ApiResultOfString {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: string | undefined;
}

export interface AuthenticatedRequestOfWithdrawPinRequest {
    Token: string | undefined;
    Data: WithdrawPinRequest | undefined;
}

export interface WithdrawPinRequest {
    UserId: number;
    Amount: Money | undefined;
    Pin: string | undefined;
    OperatorId: number | undefined;
}

export interface ApiResultOfWalletTransaction {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: WalletTransaction | undefined;
}

export interface AuthenticatedRequestOfTransactionDateRequest {
    Token: string | undefined;
    Data: TransactionDateRequest | undefined;
}

export interface TransactionDateRequest {
    Datestart: Date;
    Dateend: Date;
    GroupIds: number[] | undefined;
    UserId: number;
    Page: number;
    PageSize: number;
}

export interface ApiResultOfListOfTransactionDateResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: TransactionDateResponse[] | undefined;
}

export interface TransactionDateResponse {
    Id: number;
    IdGameServer: number;
    GameServer: GameServer | undefined;
    TransactionId: string | undefined;
    Type: WalletTransactionType;
    TransactionTime: Date;
    LasTransactionId: string | undefined;
    UserId: number;
    User: User | undefined;
    UserLastTransaction: User | undefined;
    CashierUserId: number | undefined;
    CashierUser: User | undefined;
    IdPlayerSession: number;
    PlayerSession: PlayersSession | undefined;
    NoncashableAmount: Money | undefined;
    NoncashableBalance: Money | undefined;
    CashableAmount: Money | undefined;
    CashableBalance: Money | undefined;
    DepositMoneyAmount: Money | undefined;
    DepositMoneyBalance: Money | undefined;
    DepositPromoAmount: Money | undefined;
    DepositPromoBalance: Money | undefined;
    GroupId: number;
    GroupName: string | undefined;
    MoneyAmount: Money | undefined;
    MoneyBalance: Money | undefined;
    PromoAmount: Money | undefined;
    PromoBalance: Money | undefined;
    InitialBalance: Money | undefined;
    PromotionName: string | undefined;
    PromotionDetails: PromotionDetail[] | undefined;
    GroupIds: number[] | undefined;
    GameId: number;
}

export interface PromotionDetail {
    CampaignsId: number;
    Amount: Money | undefined;
    InitialBalance: Money | undefined;
    Balance: Money | undefined;
    StartDate: Date;
    ExpirationDate: Date;
    CampaignType: string | undefined;
    PromotionName: string | undefined;
    Description: string | undefined;
    StartAmount: Money | undefined;
}

export interface AuthenticatedRequestOfUserbyTransactionRequest {
    Token: string | undefined;
    Data: UserbyTransactionRequest | undefined;
}

export interface UserbyTransactionRequest {
    UserId: number;
    Page: number;
    PageSize: number;
}

export interface ApiResultOfPaginatedUserbyTransactionResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: PaginatedUserbyTransactionResponse | undefined;
}

export interface PaginatedUserbyTransactionResponse {
    Items: UserbyTransactionResponse[] | undefined;
    TotalPages: number;
    CurrentPage: number;
    PageSize: number;
    TotalItems: number;
    HasNextPage: boolean;
    HasPreviousPage: boolean;
}

export interface UserbyTransactionResponse {
    WalletTransactionId: number;
    TransactionId: string | undefined;
    Type: string | undefined;
    TransactionTime: Date;
    UserId: number;
    FirstName: string | undefined;
    LastName: string | undefined;
    Email: string | undefined;
    CountryCode: string | undefined;
    CurrencyCode: string | undefined;
    CashableAmount: Money | undefined;
    CashableBalance: Money | undefined;
    MoneyTransactionAmount: Money | undefined;
    MoneyTransactionBalance: Money | undefined;
    PromotionDetails: PromotionDetail[] | undefined;
}

export interface AuthenticatedRequestOfTransactionperuserRequest {
    Token: string | undefined;
    Data: TransactionperuserRequest | undefined;
}

export interface TransactionperuserRequest {
    UserId: number | undefined;
    startdate: Date;
    enddate: Date;
}

export interface ApiResultOfListOfTransactionperuserResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: TransactionperuserResponse[] | undefined;
}

export interface TransactionperuserResponse {
    UserId: number;
    FirstName: string | undefined;
    Mdeposit: Money | undefined;
    Mwithdraw: Money | undefined;
    Pdeposit: Money | undefined;
    Pwithdraw: Money | undefined;
    DepositCashable: Money | undefined;
    WithdrawCashable: Money | undefined;
}

export interface AuthenticatedRequestOfWalletTransactionRequest {
    Token: string | undefined;
    Data: WalletTransactionRequest | undefined;
}

export interface WalletTransactionRequest {
    Datestart: Date;
    Dateend: Date;
    GroupIds: number[] | undefined;
}

export interface ApiResultOfListOfReportGameResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: ReportGameResponse[] | undefined;
}

export interface ReportGameResponse {
    Id: number;
    LoadToken: string | undefined;
    AuthToken: string | undefined;
    Date: Date;
    Start: Date;
    End: Date;
    PlayerId: number | undefined;
    PlayerName: string | undefined;
    GameId: number | undefined;
    GameName: string | undefined;
    GameCode: string | undefined;
    CashableAmount: Money | undefined;
    GameServerName: string | undefined;
    CashierUserName: string | undefined;
    Type: WalletTransactionType;
    NoncashableAmount: Money | undefined;
    NoncashableBalance: Money | undefined;
    CashableBalance: Money | undefined;
    GroupId: number;
    GroupName: string | undefined;
}

export interface AuthenticatedRequestOfLinkGameRoundRequest {
    Token: string | undefined;
    Data: LinkGameRoundRequest | undefined;
}

export interface LinkGameRoundRequest {
    UserId: number;
    GameRoundId: string | undefined;
    CountryCode: string | undefined;
}

export interface ApiResultOfLinkGameRoundResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: LinkGameRoundResponse | undefined;
}

export interface LinkGameRoundResponse {
    Link: string | undefined;
}

export interface AuthenticatedRequestOfGameRoundRequetsDTO {
    Token: string | undefined;
    Data: GameRoundRequetsDTO | undefined;
}

export interface GameRoundRequetsDTO {
    GroupIds: number[] | undefined;
    Datestart: Date;
    Dateend: Date;
    UserId: number;
    Page: number | undefined;
}

export interface ApiResultOfPaginatedGameRoundResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: PaginatedGameRoundResponse | undefined;
}

export interface PaginatedGameRoundResponse {
    Items: GameRound[] | undefined;
    TotalPages: number;
    CurrentPage: number;
    TotalItems: number;
}

export interface AuthenticatedRequestOfDataRequest {
    Token: string | undefined;
    Data: DataRequest | undefined;
}

export interface DataRequest {
    Datestart: Date;
    Dateend: Date;
    TransactionType: WalletTransactionType | undefined;
    PlayerId: number | undefined;
    GameId: number | undefined;
    UserId: number | undefined;
    GroupIds: number[] | undefined;
    ParentId: number | undefined;
    PlayerSessionId: number | undefined;
}

export interface ApiResultOfGroupedDataResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: GroupedDataResponse | undefined;
}

export interface GroupedDataResponse {
    Groups: GroupData[] | undefined;
    Totals: GroupData | undefined;
}

export interface GroupData {
    GroupId: number;
    GroupName: string | undefined;
    ParentId: number | undefined;
    ParentName: string | undefined;
    TotalDepositMoney: Money | undefined;
    TotalWithdrawMoney: Money | undefined;
    TotalDepositPromo: Money | undefined;
    TotalWithdrawPromo: Money | undefined;
    TotalDebitMoney: Money | undefined;
    TotalCreditMoney: Money | undefined;
    TotalEndRoundMoney: Money | undefined;
    TotalCancelBetMoney: Money | undefined;
    TotalDepositCancelMoney: Money | undefined;
    TotalWithdrawCancelMoney: Money | undefined;
    TotalWithdrawWaitingMoney: Money | undefined;
    TotalPromoCanceledMoney: Money | undefined;
    TotalPromoExpiredMoney: Money | undefined;
    Games: GameStatistics[] | undefined;
    Profit: Money | undefined;
    ProfitPercentage: number;
}

export interface GameStatistics {
    GameName: string | undefined;
    TotalJugadas: number;
    TotalJugadores: number;
}

export interface AuthenticatedRequestOfDataRequestCashier {
    Token: string | undefined;
    Data: DataRequestCashier | undefined;
}

export interface DataRequestCashier {
    Datestart: Date;
    Dateend: Date;
    OperatorId: number | undefined;
}

export interface ApiResultOfListOfDetailsPerCashierResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: DetailsPerCashierResponse[] | undefined;
}

export interface DetailsPerCashierResponse {
    UserId: number;
    FirstName: string | undefined;
    Mdeposit: Money | undefined;
    Mwithdraw: Money | undefined;
    Pdeposit: Money | undefined;
    Pwithdraw: Money | undefined;
    DepositCashable: Money | undefined;
    WithdrawCashable: Money | undefined;
}

export interface AuthenticatedRequestOfDataRequestCashierDetails {
    Token: string | undefined;
    Data: DataRequestCashierDetails | undefined;
}

export interface DataRequestCashierDetails {
    Datestart: Date;
    Dateend: Date;
    OperatorId: number | undefined;
}

export interface ApiResultOfDetailsPerCashierResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: DetailsPerCashierResponse | undefined;
}

export interface ApiResultOfDataResponseCashier {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: DataResponseCashier | undefined;
}

export interface DataResponseCashier {
    TotalDepositMoney: Money | undefined;
    TotalWithdrawMoney: Money | undefined;
    TotalDepositPromo: Money | undefined;
    TotalWithdrawPromo: Money | undefined;
    TotalDebitMoney: Money | undefined;
    TotalCreditMoney: Money | undefined;
    TotalEndRoundMoney: Money | undefined;
    TotalCancelBetMoney: Money | undefined;
    TotalDepositCancelMoney: Money | undefined;
    TotalWithdrawCancelMoney: Money | undefined;
    TotalWithdrawWaitingMoney: Money | undefined;
    TotalPromoCanceledMoney: Money | undefined;
    TotalPromoExpiredMoney: Money | undefined;
    Profit: Money | undefined;
    ProfitPercentage: number;
}

export interface ApiResultOfListOfGame {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: Game[] | undefined;
}

export interface ApiResultOfListOfUser {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: User[] | undefined;
}

export interface ApiResultOfListOfWalletTransaction {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: WalletTransaction[] | undefined;
}

export interface AuthenticatedRequestOfAssignGroupRequest {
    Token: string | undefined;
    Data: AssignGroupRequest | undefined;
}

export interface AssignGroupRequest {
    Id: number;
    GroupId: number;
}

export interface ApiResultOfAssignGroupResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: AssignGroupResponse | undefined;
}

export interface AssignGroupResponse {
    Id: number;
    GroupId: number | undefined;
}

export interface AuthenticatedRequestOfDisableGameDTO {
    Token: string | undefined;
    Data: DisableGameDTO | undefined;
}

export interface DisableGameDTO {
    Id: number;
    Enabled: boolean;
}

export interface ApiResultOfPublicGamesDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: PublicGamesDTO | undefined;
}

export interface PublicGamesDTO {
    Id: number;
    GameName: string | undefined;
    GameCode: string | undefined;
    Enabled: boolean;
    Select: string | undefined;
    ShowOnMainPage: boolean;
}

export interface AuthenticatedRequestOfDisableInPageDTO {
    Token: string | undefined;
    Data: DisableInPageDTO | undefined;
}

export interface DisableInPageDTO {
    Id: number;
    ShowOnMainPage: boolean;
}

export interface AuthenticatedRequestOfDeleteGroupDTO {
    Token: string | undefined;
    Data: DeleteGroupDTO | undefined;
}

export interface DeleteGroupDTO {
    Id: number;
}

export interface ApiResultOfDeleteGroupResponseDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: DeleteGroupResponseDTO | undefined;
}

export interface DeleteGroupResponseDTO {
    Id: number;
    Name: string | undefined;
    ParentId: number | undefined;
    Message: string | undefined;
}

export interface ApiResult {
    Success: boolean;
    ErrorMessage: string | undefined;
}

export interface AddUserWithPinDTO {
    Role: UserRole;
    FirstName: string | undefined;
    LastName: string | undefined;
    PhoneNumber: string | undefined;
    Email: string | undefined;
    Enabled: boolean;
    Birthday: Date;
    Reference: string | undefined;
    Password: string | undefined;
    CountryCode: string | undefined;
    Language: string | undefined;
    CurrencyCode: string | undefined;
    GroupId: number;
    Dailylimit: Money | undefined;
    Txlimit: Money | undefined;
}

export interface ApiResultOfPublicUserDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: PublicUserDTO | undefined;
}

export interface PublicUserDTO {
    Id: number;
    FirstName: string | undefined;
    LastName: string | undefined;
    Email: string | undefined;
    PhoneNumber: string | undefined;
    Password: string | undefined;
    Role: UserRole;
    Enabled: boolean;
    BirthdayDay: Date;
    CountryCode: string | undefined;
    CurrencyCode: string | undefined;
    Reference: string | undefined;
    GroupId: number | undefined;
    LastTransaction: WalletTransaction | undefined;
    Dailylimit: Money | undefined;
    Txlimit: Money | undefined;
}

export interface AuthenticatedRequestOfAddUserDTO {
    Token: string | undefined;
    Data: AddUserDTO | undefined;
}

export interface AddUserDTO {
    Role: UserRole;
    FirstName: string | undefined;
    LastName: string | undefined;
    PhoneNumber: string | undefined;
    Password: string | undefined;
    Email: string | undefined;
    Enabled: boolean;
    Birthday: Date;
    Reference: string | undefined;
    CountryCode: string | undefined;
    Language: string | undefined;
    CurrencyCode: string | undefined;
    GroupId: number;
    Dailylimit: Money | undefined;
    Txlimit: Money | undefined;
}

export interface AuthenticatedRequestOfDisableUserDTO {
    Token: string | undefined;
    Data: DisableUserDTO | undefined;
}

export interface DisableUserDTO {
    Id: number;
    Enabled: boolean;
}

export interface AuthenticatedRequestOfEditUserDTO {
    Token: string | undefined;
    Data: EditUserDTO | undefined;
}

export interface EditUserDTO {
    Id: number;
    FirstName: string | undefined;
    LastName: string | undefined;
    Email: string | undefined;
    PhoneNumber: string | undefined;
    Enabled: boolean;
    CountryCode: string | undefined;
    CurrencyCode: string | undefined;
    Reference: string | undefined;
    NewPassword: string | undefined;
    GroupId: number;
    Language: string | undefined;
    Txlimit: Money | undefined;
}

export interface AuthenticatedRequestOfPrintAddUserDTO {
    Token: string | undefined;
    Data: PrintAddUserDTO | undefined;
}

export interface PrintAddUserDTO {
    Id: number;
}

export interface AuthenticatedRequestOfPrintEditUserDTO {
    Token: string | undefined;
    Data: PrintEditUserDTO | undefined;
}

export interface PrintEditUserDTO {
    Id: number;
}

export interface AuthenticatedRequestOfPrintUserDTO {
    Token: string | undefined;
    Data: PrintUserDTO | undefined;
}

export interface PrintUserDTO {
    Id: number;
}

export interface LoginWalletDTO {
    email: string | undefined;
    PhoneNumber: string | undefined;
    password: string | undefined;
    TurnstileToken: string | undefined;
}

export interface ApiResultOfLoginDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: LoginDTO | undefined;
}

export interface LoginDTO {
    User: PublicUserDTO | undefined;
    Token: string | undefined;
}

export interface CashierSettings {
    DepositCashMode: DepositCashMode;
    NoncashableMode_NoncashableName: string | undefined;
    NoncashableMode_CashableName: string | undefined;
    CashableMode_NoncashableName: string | undefined;
    CashableMode_CashableName: string | undefined;
    Currency: Currency | undefined;
}

export enum DepositCashMode {
    Cashable = "Cashable",
    Noncashable = "Noncashable",
}

export interface Currency {
    Prefix: string | undefined;
    Suffix: string | undefined;
}

export interface AuthenticatedRequestOfDepositWithdrawDTO {
    Token: string | undefined;
    Data: DepositWithdrawDTO | undefined;
}

export interface DepositWithdrawDTO {
    UserId: number;
    Amount: Money | undefined;
    Campaigns: CampaignWithAmount[] | undefined;
    DepositCashMode: string | undefined;
    Pin: string | undefined;
    OperatorId: number | undefined;
}

export interface CampaignWithAmount {
    Campaign: Campaigns | undefined;
    CampaignAmount: Money | undefined;
}

export interface AuthenticatedRequestOfCancelTransactionRequest {
    Token: string | undefined;
    Data: CancelTransactionRequest | undefined;
}

export interface CancelTransactionRequest {
    TransactionId: number;
}

export interface AuthenticatedRequestOfPrintTransactionDTO {
    Token: string | undefined;
    Data: PrintTransactionDTO | undefined;
}

export interface PrintTransactionDTO {
    Id: number;
}

export interface AuthenticatedRequestOfAddBannerDTO {
    Token: string | undefined;
    Data: AddBannerDTO | undefined;
}

export interface AddBannerDTO {
    BannerName: string | undefined;
    BigSelect: string | undefined;
    SmallSelect: string | undefined;
    Link: string | undefined;
    Enabled: boolean;
}

export interface ApiResultOfBannersDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: BannersDTO | undefined;
}

export interface BannersDTO {
    Id: number;
    BannerName: string | undefined;
    BigSelect: string | undefined;
    SmallSelect: string | undefined;
    Link: string | undefined;
    Enabled: boolean;
}

export interface ApiResultOfListOfBannersDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: BannersDTO[] | undefined;
}

export interface AuthenticatedRequestOfEditBannerDTO {
    Token: string | undefined;
    Data: EditBannerDTO | undefined;
}

export interface EditBannerDTO {
    Id: number;
    BannerName: string | undefined;
    BigSelect: string | undefined;
    SmallSelect: string | undefined;
    Link: string | undefined;
    Enabled: boolean;
}

export interface AuthenticatedRequestOfDisableBannerDTO {
    Token: string | undefined;
    Data: DisableBannerDTO | undefined;
}

export interface DisableBannerDTO {
    Id: number;
    Enabled: boolean;
}

export interface ApiResultOfListOfCampaignsDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: CampaignsDTO[] | undefined;
}

export interface CampaignsDTO {
    Id: number;
    Type: TypePromotion;
    PromotionName: string | undefined;
    Description: string | undefined;
    StartAmount: Money | undefined;
    DepositRequired: boolean;
    Active: boolean;
    TotalDays: string;
    ExpirationDate: Date;
    Settings: string | undefined;
    DurationDisplay: string | undefined;
    Days: number;
    Hours: number;
    Minutes: number;
    Seconds: number;
    UserPromotional: UserPromotional[] | undefined;
}

export interface AuthenticatedRequestOfAddCampaignsDTO {
    Token: string | undefined;
    Data: AddCampaignsDTO | undefined;
}

export interface AddCampaignsDTO {
    Type: TypePromotion;
    PromotionName: string | undefined;
    Description: string | undefined;
    StartAmount: Money | undefined;
    DepositRequired: boolean;
    Active: boolean;
    ExpirationDate: Date;
    Settings: string | undefined;
    UserPromotional: UserPromotional[] | undefined;
    Days: number | undefined;
    Hours: number | undefined;
    Minutes: number | undefined;
    Seconds: number | undefined;
    TotalDays: string;
}

export interface ApiResultOfCampaignsDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: CampaignsDTO | undefined;
}

export interface AuthenticatedRequestOfEditCampaignsDTO {
    Token: string | undefined;
    Data: EditCampaignsDTO | undefined;
}

export interface EditCampaignsDTO {
    Id: number;
    Type: TypePromotion;
    PromotionName: string | undefined;
    Description: string | undefined;
    StartAmount: Money | undefined;
    DepositRequired: boolean;
    Active: boolean;
    ExpirationDate: Date;
    Settings: string | undefined;
    Days: number | undefined;
    Hours: number | undefined;
    Minutes: number | undefined;
    Seconds: number | undefined;
    TotalDays: string;
}

export interface AuthenticatedRequestOfAddGroupLimitDto {
    Token: string | undefined;
    Data: AddGroupLimitDto | undefined;
}

export interface AddGroupLimitDto {
    GroupId: number | undefined;
    UserId: number | undefined;
    InitialBalance: Money | undefined;
    Balance: Money | undefined;
    DateTransaction: Date;
    Active: boolean | undefined;
}

export interface ApiResultOfGroupLimitResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: GroupLimitResponse | undefined;
}

export interface GroupLimitResponse {
    Id: number;
    GroupId: number | undefined;
    UserId: number | undefined;
    InitialBalance: Money | undefined;
    Balance: Money | undefined;
    DateTransaction: Date;
    Active: boolean | undefined;
}

export interface ApiResultOfListOfGroupLimitResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: GroupLimitResponse[] | undefined;
}

export interface AuthenticatedRequestOfEditGroupLimitDTO {
    Token: string | undefined;
    Data: EditGroupLimitDTO | undefined;
}

export interface EditGroupLimitDTO {
    Id: number;
    GroupId: number | undefined;
    UserId: number | undefined;
    InitialBalance: Money | undefined;
    Balance: Money | undefined;
    DateTransaction: Date | undefined;
    Active: boolean | undefined;
}

export interface ApiResultOfGroupLimitDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: GroupLimitDTO | undefined;
}

export interface GroupLimitDTO {
    Id: number;
    GroupId: number | undefined;
    UserId: number | undefined;
    InitialBalance: Money | undefined;
    Balance: Money | undefined;
    DateTransaction: Date;
    Active: boolean | undefined;
}

export interface AuthenticatedRequestOfDisableGroupLimitDto {
    Token: string | undefined;
    Data: DisableGroupLimitDto | undefined;
}

export interface DisableGroupLimitDto {
    Id: number;
    Active: boolean;
}

export interface AuthenticatedRequestOfTransactionbyLimitDTO {
    Token: string | undefined;
    Data: TransactionbyLimitDTO | undefined;
}

export interface TransactionbyLimitDTO {
    GroupLimitId: number;
}

export interface ApiResultOfTransactionbyLimitResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: TransactionbyLimitResponse | undefined;
}

export interface TransactionbyLimitResponse {
    GroupLimitId: number;
    GroupId: number | undefined;
    UserId: number | undefined;
    InitialBalance: Money | undefined;
    Balance: Money | undefined;
    DateTransaction: Date;
    Active: boolean | undefined;
    GroupLimits: GroupLimits | undefined;
    Transactions: TransactionbyLimitItem[] | undefined;
    TotalTransactions: number;
}

export interface GroupLimits {
    Id: number;
    GroupId: number | undefined;
    Group: Group | undefined;
    UserId: number | undefined;
    Users: User | undefined;
    InitialBalance: Money | undefined;
    Balance: Money | undefined;
    DateTransaction: Date;
    Active: boolean | undefined;
}

export interface TransactionbyLimitItem {
    LimitTransactionId: number;
    GroupLimitsId: number | undefined;
    InitialBalance: Money | undefined;
    Balance: Money | undefined;
    TransactionTime: Date;
}

export interface AuthenticatedRequestOfAddConfigurationDTO {
    Token: string | undefined;
    Data: AddConfigurationDTO | undefined;
}

export interface AddConfigurationDTO {
    Key: string | undefined;
    Value: string | undefined;
}

export interface ApiResultOfConfigurationResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: ConfigurationResponse | undefined;
}

export interface ConfigurationResponse {
    Id: number;
    Key: string | undefined;
    Value: string | undefined;
}

export interface ApiResultOfListOfConfigurationResponse {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: ConfigurationResponse[] | undefined;
}

export interface AuthenticatedRequestOfEditConfigurationDTO {
    Token: string | undefined;
    Data: EditConfigurationDTO | undefined;
}

export interface EditConfigurationDTO {
    Id: number;
    Key: string | undefined;
    Value: string | undefined;
}

export interface ApiResultOfConfigurationDTO {
    Success: boolean;
    ErrorMessage: string | undefined;
    Message: string | undefined;
    Data: ConfigurationDTO | undefined;
}

export interface ConfigurationDTO {
    Id: number;
    Key: string | undefined;
    Value: string | undefined;
}

export interface Banners {
    Id: number;
    BannerName: string | undefined;
    BigSelect: string | undefined;
    SmallSelect: string | undefined;
    Link: string | undefined;
    Enabled: boolean;
}

export interface Configuration {
    Id: number;
    Key: string | undefined;
    Value: string | undefined;
}